import { useEffect, useRef, useState } from 'react';
import { BEMBlock } from 'helpers/classnames';
import { Breadcrumb } from 'palette/Breadcrumb';
import BreadcrumbItem from 'palette/Breadcrumb/BreadcrumbItem';
import { Button } from 'palette/Button';
import { formatBreadcrumbItems } from '@common/Breadcrumbs/helpers';
import { useConfig } from '@common/Hooks/useConfig';
import './styles/BurgerNavBreadcrumbs.scss';

export function BurgerNavBreadcrumbs({
    breadcrumbs, backButtonClick, currentNavItem, navigationStateFromPath, navigationPath
}) {
    const config = useConfig();
    const [block, BEMElement] = BEMBlock('burger-nav-breadcrumbs');
    const breadcrumbUrl = breadcrumbs.map(breadcrumb => (breadcrumb.url));
    const isBreadcrumbsSame = breadcrumbUrl?.[breadcrumbUrl.length - 1] === currentNavItem?.trackingUrl;
    const navPath = navigationStateFromPath(navigationPath);
    const breadcrumbBurger = [navPath.rootNavigation, navPath.currentNavItem];
    const burgerBreadcrumbs = isBreadcrumbsSame ? breadcrumbs : breadcrumbBurger;
    const formattedBreadcrumbItems = formatBreadcrumbItems(burgerBreadcrumbs, 'text', config);

    const ellipsis = '.../';

    const itemRef = useRef({});
    const breadcrumbRef = useRef();
    const isCalculationDone = useRef(false);
    const [numberOfPassingItems, setNumberOfPassingItems] = useState();
    const isOverflowing = burgerBreadcrumbs.length > numberOfPassingItems;
    const slicedBreadcrumbItems = numberOfPassingItems !== undefined
        ? formattedBreadcrumbItems.slice(burgerBreadcrumbs.length && burgerBreadcrumbs - numberOfPassingItems)
        : formattedBreadcrumbItems;

    useEffect(() => {
        if (isCalculationDone.current) return;

        const itemWidth = Object.values(itemRef.current).map(item => item?.offsetWidth).reverse();
        const itemWidthSum = itemWidth.reduce((prev, curr) => [
            ...prev,
            curr + (prev[prev.length - 1] ?? 0)
        ], []);
        const matchedIndex = itemWidthSum.findIndex(width => width > breadcrumbRef.current?.offsetWidth);
        setNumberOfPassingItems(matchedIndex > 0 ? matchedIndex : itemWidthSum.length);
        isCalculationDone.current = true;
    }, [numberOfPassingItems]);

    return (
        <div className={block}>
            <Button
                isTransparent
                className={BEMElement('back-btn')}
                horizontalAlignment="left"
                iconName="palette_chevron_left"
                size="x-small"
                theme="secondary"
                onClick={backButtonClick}
            />
            {isOverflowing && <div className={BEMElement('separator')}>{ellipsis}</div>}
            <Breadcrumb
                ref={breadcrumbRef}
                className={BEMElement('nav')}
            >

                {slicedBreadcrumbItems.map(item => (
                    <BreadcrumbItem
                        ref={itemRef}
                        item={item}
                        items={slicedBreadcrumbItems}
                    />
                ))}

            </Breadcrumb>
        </div>
    );
}
